// src/index.ts
import { useEffect, useRef } from "react";
import equal from "@gilbarbara/deep-equal";
import treeChanges from "tree-changes";
function useTreeChanges(value) {
  const previousValue = useRef(value);
  const isEqual = equal(previousValue.current, value);
  const previousIsEqual = useRef(isEqual);
  const instance = useRef(
    treeChanges(previousValue.current, value)
  );
  useEffect(() => {
    previousValue.current = value;
  });
  if (previousIsEqual.current !== isEqual || !isEqual) {
    previousIsEqual.current = isEqual;
    instance.current = treeChanges(previousValue.current, value);
  }
  return instance.current;
}
export {
  useTreeChanges as default,
  treeChanges
};
//# sourceMappingURL=index.mjs.map